export default {
  "title": "개발자 실무 역량 평가 ｜ 주요 직무 기반 온라인 코딩 테스트 코드프레소",
  "description": "주요 직무 중심의 프로젝트형 평가로 개발자의 실무 역량을 정밀하게 검증하세요. 지원자별 상세 리포트를 통해 핵심 역량과 직무 적합성을 정확하게 파악할 수 있습니다.",
  "ogTitle": "개발자 실무 역량 평가 ｜ 주요 직무 기반 온라인 코딩 테스트 코드프레소",
  "ogDescription": "주요 직무 중심의 프로젝트형 평가로 개발자의 실무 역량을 정밀하게 검증하세요. 지원자별 상세 리포트를 통해 핵심 역량과 직무 적합성을 정확하게 파악할 수 있습니다.",
  "home": {
    "skillCertify": {
      "title": "직무별 온라인 코딩 테스트",
      "meta": {
        "title": "코드프레소 - 직무별 온라인 코딩 테스트",
        "description": "AI, 프론트엔드, 백엔드, DevOps 등 다양한 직무와 언어별 테스트로 실무 역량을 정확히 검증하세요."
      }
    },
    "skillMonitor": {
      "title": "개인별 상세 역량 리포트",
      "meta": {
        "title": "코드프레소 - 개인별 상세 역량 리포트",
        "description": "평가 결과 리포트를 통해 응시자의 상세 직무 역량을 확인하세요."
      }
    },
    "skillAdvance": {
      "title": "맞춤형 업스킬링 및 리스킬링",
      "meta": {
        "title": "코드프레소 - 맞춤형 업스킬링 및 리스킬링",
        "description": "평가 결과 기반 개인별 맞춤형 학습 로드맵과 콘텐츠를 경험하세요."
      }
    },
    "hiring": {
      "title": "개발자 채용 평가 사례",
      "meta": {
        "title": "코드프레소 - 개발자 채용 평가 사례",
        "description": "다양한 기업들이 개발자 채용 평가를 어떻게 혁신하고 있는지 알아보세요."
      }
    }
  }
};